import { EnrollApi } from 'api';
import { useAuthMutation } from 'queries/query';

function usePostEnrollResponse() {
  return useAuthMutation(EnrollApi.postEnrollResponse);
}

export default usePostEnrollResponse;
